import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/global.css"; // This now imports the consolidated stylesheet
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { BASE_PATH } from "@/utils/basePath";

const container =
    typeof document !== "undefined" ? document.getElementById("root") : null;
if (!container) throw new Error("Root container not found");

// BASE_PATH comes from import.meta.env.BASE_URL, which Vite guarantees is normalised and which is the
// same value it used to rewrite asset URLs in index.html. The previous implementation hand-parsed
// VITE_BASE_URL (including a branch for it being an absolute URL), which could disagree with what the
// bundle actually shipped. React Router accepts "/" for a root mount.

createRoot(container).render(
    <React.StrictMode>
        <BrowserRouter basename={BASE_PATH || "/"}>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
